import { InferType, object, string } from 'yup'
import moment from 'moment'

const nameSchema = string()
  .matches(/^[\w\s-.]*$/, 'Invalid Name')
  .notRequired()
  .nullable()
  .default('')

export const MembersFiltersSchema = object({
  firstName: nameSchema.label('First Name'),
  lastName: nameSchema.label('Last Name'),
  firstNamePreferred: nameSchema.label('Preferred Name'),
  dob: string()
    .label('Date of Birth')
    .notRequired()
    .nullable()
    .test('validDate', 'Invalid date', function (date) {
      if (!date) return true
      return moment(date, 'MM-DD-YYYY').isValid()
    })
    .test('maxDate', 'Date of Birth cannot be in the future', function (date) {
      if (!date) return true
      const dateObj = moment(date, 'MM-DD-YYYY').startOf('day')
      return dateObj.isBefore(moment().endOf('day'))
    })
    .default(''),
})
export type MembersFiltersValues = InferType<typeof MembersFiltersSchema>
